import axios from '../utils/axios';

// {"code":1,"msg":"","data":[{"nickname":"\ud83d\udd0b111","avatar":"111","unionid":"11"}]}
export function login(code) {
  return axios.post(`/user/userLogin?code=${code}`);
}